export default __webpack_public_path__ + "static/media/Tommie_Obama.8b2dc271.jpg";